<template>
  <div id="tst">
    <v-tooltip bottom v-if="zip">
      <v-btn slot="activator" @click="dialog = true" class="d-inline bg_white btnMargin">
        <v-icon
          class="material-icons"
          style="margin-left: -5px;margin-right: 8px;"
          small
          color="teal"
        >email</v-icon>
        <small>E-mail</small>
      </v-btn>
      <span>{{component.name == 'NFSE' ? 'Enviar XML das notas selecionadas por e-mail':'Enviar PDF e XML das notas selecionadas por e-mail'}}</span>
    </v-tooltip>
    <v-tooltip bottom v-else>
      <v-btn slot="activator" icon small flat @click="dialog = true">
        <v-icon class="material-icons">email</v-icon>
      </v-btn>
      <span>{{component.name == 'NFSE' ? 'Enviar XML por e-mail':'Enviar PDF e XML por e-mail'}}</span>
    </v-tooltip>
    <v-dialog v-model="dialog" max-width="500px" :lazy="true">
      <v-card>
        <v-card-title class="headline darkBlue" text-color="white" style="color: white;">
          Enviar E-mail
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-progress-linear
          color="teal"
          style="margin: 0;"
          v-if="this.sendingMail"
          :indeterminate="true"
        ></v-progress-linear>
        <v-combobox
          v-model="model"
          :filter="filter"
          :hide-no-data="!search"
          :items="items"
          :search-input.sync="search"
          hide-selected
          label="E-mail:"
          multiple
          small-chips
          solo
          class="email_combo"
          content-class="email_combo"
        >
          <template slot="no-data" style="max">
            <v-list-tile style="max-height: 110px;">
              <small>
                Aperte
                <b>enter</b> para adicionar o e-mail
              </small>
              <br>
              <v-chip
                class="env_email"
                :title="search"
                :color="`${colors[nonce - 1]} lighten-3`"
                label
                small
              >{{ search }}</v-chip>
            </v-list-tile>
          </template>
          <template
            v-if="item === Object(item)"
            slot="selection"
            slot-scope="{ item, parent, selected }"
          >
            <v-chip :color="`${item.color} lighten-3`" :selected="selected" label small>
              <span class="pr-2">{{ item.text }}</span>
              <v-icon small @click="parent.selectItem(item)">close</v-icon>
            </v-chip>
          </template>
          <template slot="item" slot-scope="{ index, item, parent }">
            <v-list-tile-content>
              <v-text-field
                @click.stop.prevent
                v-if="editing === item"
                v-model="editing.text"
                autofocus
                flat
                background-color="transparent"
                hide-details
                solo
                @keyup.enter="edit(index, item)"
              ></v-text-field>
              <v-chip v-else :color="`${item.color} lighten-3`" dark label small>{{ item.text }}</v-chip>
            </v-list-tile-content>
            <v-spacer></v-spacer>
            <v-list-tile-action @click.stop>
              <v-btn icon @click.stop.prevent="edit(index, item)">
                <v-icon>{{ editing !== item ? 'edit' : 'check' }}</v-icon>
              </v-btn>
            </v-list-tile-action>
            <v-list-tile-action @click.stop>
              <v-btn icon @click.stop.prevent="middleDel(item)">
                <v-icon>delete</v-icon>
              </v-btn>
            </v-list-tile-action>
          </template>
        </v-combobox>
        <v-card-actions style="padding-top: 93px;">
          <v-btn color="red" flat @click.stop="dialog=false">Fechar</v-btn>
          <v-btn color="teal" dark @click.native="enviarEmail()">Enviar</v-btn>
          <v-spacer></v-spacer>
          <v-layout v-if="this.component.name != 'NFSE'" row wrap justify-end>
            <v-flex d-flex xs6 sm8 md8>
              <v-checkbox
                color="green"
                :label="this.component.name == 'CTE' ? 'Dacte' : 'Danfe'"
                v-model="chkDanfe"
              ></v-checkbox>
              <v-checkbox color="green" :label="'XML'" v-model="chkXml"></v-checkbox>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete" max-width="400">
      <v-card>
        <v-card-title class="headline">
          <small>Confirmar remoção de e-mail</small>
        </v-card-title>
        <hr>
        <v-card-text>
          Deseja remover "
          <strong>{{mailDelete ? mailDelete.text : ''}}</strong>" da lista ?
        </v-card-text>
        <hr>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="error" small flat="flat" @click="delMail(false)">Cancelar</v-btn>

          <v-btn small color="success" @click="delMail(true)">Remover</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
      id="snack"
    >
      {{ text }}
      <v-btn color="orange" flat @click="snackbar = false">Fechar</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import CommonService from "@/domain/dataTable/commonService/CommonService.js";
import UsuarioService from "@/domain/conta/usuario/UsuarioService.js";
export default {
  props: ["id_nota", "component", "table", "conta", "zip", "empresa"],
  data: () => ({
    dialog: false,
    email: "",
    emailRules: [v => !!v || "Campo obrigatório"],
    snackbar: false,
    y: "bottom",
    x: null,
    mode: "",
    timeout: 5000,
    text: "",
    chkDanfe: true,
    chkXml: true,
    activator: null,
    attach: null,
    colors: ["green", "purple", "indigo", "cyan", "teal", "orange"],
    editing: null,
    index: -1,
    items: [{ header: "Selecione uma opção ou digite um e-mail" }],
    nonce: 1,
    menu: false,
    mailDelete: "",
    model: [],
    x: 0,
    search: null,
    y: 0,
    auxEmail: "",
    sendingMail: false,
    dialogDelete: false
  }),
  mounted: function() {
    // this.$nextTick(function() {});
  },
  watch: {
    model(val, prev) {
      if (val.length === prev.length) return;
      this.model = val.map(v => {
        if (v != undefined && v.text != undefined) {
          return v;
        }
        if (
          typeof v === "string" &&
          /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(v)
        ) {
          v = {
            text: v,
            color: this.colors[this.nonce - 1]
          };
          this.items.push(v);

          this.nonce++;
          return v;
        }
      });
    },
    dialog(val, prev) {
      if (val) {
        if (this.zip) {
          if (this.id_nota && this.id_nota.length == 0) {
            this.table.snackAlert();
            this.table.snack.text = "Necessário selecionar ao menos uma nota.";
            this.table.snack.show = true;
            return (this.dialog = false);
          }
        }
        this.model = [];
        this.items = [{ header: "Selecione uma opção ou digite um e-mail" }];
        let obj = {};

        if (this.conta.favEmails && this.conta.favEmails.length > 0) {
          let favMails = this.conta.favEmails.slice();
          for (let i = 0; i < favMails.length; i++) {
            let mail = {};
            mail["text"] = favMails[i];
            mail["color"] = this.colors[
              Math.floor(Math.random() * this.colors.length)
            ];
            this.items.push(mail);
          }
        } else if (!this.conta.favEmail) {
          this.model.push(obj);
          this.items.push(obj);
          obj["text"] = this.conta.email;
          obj["color"] = "info";
        }
      }
    }
  },
  methods: {
    enviarEmail: async function() {
      if (this.model.length >= 1) {
        this.sendingMail = true;
        for (let i = 0; i < this.model.length; i++) {
          if (
            this.model[i].text.length > 0 &&
            /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(
              this.model[i].text
            )
          ) {
            if (this.component.name == "NFSE") {
              this.chkDanfe = false;
            }
            this.service = new CommonService(this.$http);
            this.table.resetAlert();
            if (this.zip) {
              this.activeGlobalLoader();
              await this.service
                .zipEmailNotas(
                  this.id_nota,
                  this.model[i].text,
                  this.chkXml,
                  this.chkDanfe,
                  this.component.name,
                  this.empresa._id
                )
                .then(res => {
                  this.table.snack.text = "Erro ao enviar E-mail";
                  if (res.ok) {
                    this.table.snack.text =
                      "Motor Fiscal enviou E-mail com as informações da nota";
                    this.dialog = false;
                  }
                  this.desactiveGlobalLoader();
                });
            } else {
              await this.service
                .enviarEmail(
                  this.id_nota,
                  this.model[i].text,
                  this.chkXml,
                  this.chkDanfe,
                  this.component.name,
                  this.empresa._id
                )
                .then(res => {
                  this.table.snack.text = "Erro ao enviar E-mail";
                  if (res.ok) {
                    this.table.snack.text =
                      "Motor Fiscal enviou E-mail com as informações da nota";
                    this.dialog = false;
                  }
                });
            }
          } else {
            this.table.snack.text = `E-mail inválido: ${this.model[i].text}`;
          }
        }
        this.sendingMail = false;
      } else {
        this.table.snack.text = "Insira algum E-mail.";
      }
      this.table.snack.show = true;
      this.saveMailsFavoritos();
    },
    saveMailsFavoritos: async function() {
      let favItems = [];
      for (let i = 1; i < this.items.length; i++) {
        favItems.push(this.items[i].text);
      }
      let userFavMails = {
        favEmails: favItems
      };
      this.conta["favEmails"] = favItems.slice();
      this.service = new UsuarioService(this.$http);
      this.service.editar(userFavMails, this.conta.id_usuario);
    },
    activeGlobalLoader: function() {
      const appDom = document.querySelector("#app");
      const icon = document.querySelector("#app main +i.c_custom-loader");
      const body = document.querySelector("body");
      const html = document.querySelector("html");
      body.classList.add("loading_global");
      html.classList.add("loading_global");

      appDom.classList.add("loading_global");
      icon.classList.add("loading_global");
    },
    desactiveGlobalLoader: function() {
      const appDom = document.querySelector("#app");
      const icon = document.querySelector("#app main +i.c_custom-loader");
      const body = document.querySelector("body");
      const html = document.querySelector("html");
      body.classList.remove("loading_global");
      html.classList.remove("loading_global");
      appDom.classList.remove("loading_global");
      icon.classList.remove("loading_global");
    },
    edit(index, item) {
      if (!this.editing) {
        this.editing = item;
        this.auxEmail = item.text;
        this.index = index;
      } else {
        if (
          /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(
            this.editing.text
          ) == false
        ) {
          item.text = this.auxEmail;
        }
        this.auxEmail = "";
        this.editing = null;
        this.index = -1;
      }
    },
    middleDel(item) {
      this.dialogDelete = true;
      this.mailDelete = item;
    },
    delMail(action) {
      this.dialogDelete = false;
      if (action) {
        this.items.splice(this.items.indexOf(this.mailDelete), 1);
        this.saveMailsFavoritos();
      }
      this.mailDelete = undefined;
    },
    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = val => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text
          .toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) > -1
      );
    }
  }
};
</script>
<style scoped>
#content {
  display: inline-block;
}
#ico {
  color: grey !important;
  transition: color 1 linear;
}

.v-btn {
  margin: 6px 8px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_actions/btnEmail/BtnEmail.vue